<template>
  <div class="panel_settlement">
    <div style="padding-top: 7px">
      <span class="priceItem" style="margin-right: 20px">
        <span class="label">总计：</span>
        <span class="price">￥{{ saleTotal.total }}</span>
      </span>
     
      <span class="priceItem" style="margin-right: 10px">
        <span class="label">优惠：</span>

        <el-popover
          v-if="curDiscountCard && curDiscountCard._id"
          placement="top-start"
          title=""
          width="200"
          trigger="hover"
        >
          <span
            class="priceItem"
            style="font-size: 12px"
            v-if="curDiscountCard && curDiscountCard._id"
          >
            {{ curDiscountCard.coupon_name }}({{
              $public.getDiscountType(curDiscountCard.apply_range.order_type)
            }}券)
            <span v-if="curDiscountCard.activity_type === 1">
              满{{ curDiscountCard.money_top }}元可用
            </span>
            <span v-if="curDiscountCard.activity_type === 2">
              满{{ curDiscountCard.rebate_top }}元可用，
              <span v-if="curDiscountCard.rebate_limit > 0"
                >最高抵扣{{ curDiscountCard.rebate_limit }}元</span
              >
              <span v-else></span>
            </span>
            <span
              style="color: #1890ff; cursor: pointer"
              @click="delDiscountCard"
              >删除</span
            >
          </span>
          <span class="price" slot="reference"
            >￥{{ $public.jian(saleTotal.total, saleTotal.activity) }}</span
          >
        </el-popover>

        <span class="price" v-else
          >￥{{ $public.jian(saleTotal.total, saleTotal.activity) }}</span
        >
      </span>
      <span class="priceItem" style="margin-right: 20px">
        <span class="label">会员价：</span>
        <span class="price">￥{{ saleTotal.viptotal }}</span>
      </span>
    </div>
    <div>
      <span> </span>
      <el-button
        style="width: 110px"
        type="warning"
        plain
        @click="delDiscountCard"
        v-if="curDiscountCard && curDiscountCard._id"
        size="max"
        >取消优惠券</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        plain
        @click="openDiscountCard"
        v-else
        
        size="max"
        >优惠券</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        plain
        @click="openBeizhu"
        size="max"
        >备注</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        plain
        @click="openReset('btn')"
        size="max"
        >重置</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        plain
        @click="openGuadan"
        size="max"
        >挂单</el-button
      >
      <el-button
        style="width: 80px"
        type="warning"
        plain
        @click="openJiedan"
        size="max"
        >解单</el-button
      >
      <!-- 不是会员 没有添加会员价商品  -->
      <!--  :disabled="saleTotal.activity>userYue" -->
      <el-button
       v-if="userInfo.club_card.is_valid==false&&vipIndex==-1&&userInfo.card_info.user_yue>0&&saleTotal.showVip==true"
        type="primary"
        :disabled="saleTotal.viptotal>userInfo.card_info.user_yue||saleTotal.total==saleTotal.viptotal"
        @click="submitOrder(1)"
        size="max"
        >会员价结算￥{{saleTotal.viptotal }}</el-button
      >
      <el-button
        type="warning"
        @click="submitOrder()"
        size="max"
        >结算￥{{ saleTotal.activity }}</el-button
      >
      
    </div>
    <!-- 备注弹窗 -->
    <div v-if="drawerRemark_state">
      <drawerRemark
        :type="'mendian'"
        @submit="submit_drawerRemark"
      ></drawerRemark>
    </div>
    <!-- 挂单弹窗 -->
    <div v-if="drawerRemarkGuadan_state">
      <drawerRemarkGuadan
        @submit="submit_drawerRemarkGuadan"
      ></drawerRemarkGuadan>
    </div>
    <!-- 解单弹窗 -->
    <div v-if="drawerJiedanList_state">
      <drawerJiedanList @submit="submit_drawerJiedanList"></drawerJiedanList>
    </div>
    <!-- 重置弹窗 -->
    <div v-if="drawerReset_state">
      <drawerReset @submit="submit_drawerReset"></drawerReset>
    </div>
    <!-- 结算 -->
    <div v-if="dialogSettlement_state">
      <dialogSettlement
        :type="settlement_type"
        :orderId="curOrder._id"
        @submit="dialogSettlementSubmit"
      ></dialogSettlement>
    </div>
    <!-- 优惠券 -->
    <div v-show="drawerDiscountCard_state">
      <!-- <drawerDiscountCard :state="drawerDiscountCard_state" :type="'收银'" @submit="submit_drawerDiscountCard"></drawerDiscountCard> -->
      <drawerDiscountCard
        :userId="userInfo._id"
        :state="drawerDiscountCard_state"
        :money="saleTotal.total"
        :goodsList="saleList"
        :type="1"
        @submit="submit_drawerDiscountCard"
      ></drawerDiscountCard>
    </div>
    <!-- 合单支付 -->
    <div v-if="dialogMergeOrder_state">
      <dialogMergeOrder
        :orderNoList="mergeOrderNumberList"
        @submit="submit_dialogMergeOrder"
      ></dialogMergeOrder>
    </div>
    <!-- 复购 -->
    <div v-if="dialogReBuy_state">
      <dialogReBuy
        :orderId="curOrder.no"
        @submit="submit_dialogReBuy"
      ></dialogReBuy>
    </div>
  </div>
</template>
<script>
import dialogSettlement from "../../../../components/dialog_settlement.vue";
import dialogMergeOrder from "../../../../components/dialog_mergeOrder.vue";
import drawerDiscountCard from "../drawer/discountCard.vue";
import drawerRemark from "../drawer/remark.vue";
import drawerRemarkGuadan from "../drawer/remarkGuadan.vue";
import drawerJiedanList from "../drawer/jiedanList.vue";
import drawerReset from "../drawer/reset.vue";
import dialogReBuy from "../../../dingdan/order/saleOrder/dialogReBuy.vue";
import del from "../../../../util/del.js";
export default {
  components: {
    drawerDiscountCard,
    dialogMergeOrder,
    dialogSettlement,
    drawerRemark,
    drawerReset,
    drawerRemarkGuadan,
    drawerJiedanList,
    dialogReBuy,
  },
  data() {
    return {
      // 备注
      drawerRemark_state: false,
      // 重置
      drawerReset_state: false,
      // 挂单
      drawerRemarkGuadan_state: false,
      // 解单
      drawerJiedanList_state: false,
      // guadanList:[],
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 结算
      settlement_type: "order",
      dialogSettlement_state: false,
      curOrder: {},
      //
      o: null,
      // 优惠券
      drawerDiscountCard_state: false,
      // 合并订单
      dialogMergeOrder_state: false,
      mergeOrderNumberList: [],
      // 复购
      dialogReBuy_state: false,
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    curDiscountCard() {
      return this.$store.state.mendian.curDiscountCard;
    },
    saleList() {
      return this.$store.state.mendian.saleList;
    },
    saleTotal() {
      if (this.$store.state.mendian.saleTotal) {
        console.log(this.$store.state.mendian.saleTotal);
        return this.$store.state.mendian.saleTotal;
      } else {
        return {
          total: 0,
          activity: 0,
          viptotal:0,
          showVip:false
        };
      }
    },
    jiedanItem() {
      return this.$store.state.mendian.jiedanItem;
    },
    unPayOrderList() {
      return this.$store.state.mendian.unPayOrderList;
    },
    unPayOrderNoList() {
      return this.$store.state.mendian.unPayOrderNoList;
    },
    remark() {
      return this.$store.state.mendian.remark;
    },
    vipIndex() {
      return this.$store.state.mendian.vipIndex;
    },
  },
  watch:{
   
  },
  mounted() {

    this.o = new del();
  },
  methods: {
    // 合并订单
    submit_dialogMergeOrder(obj) {
      this.$store.commit("mendian/set_curDiscountCard", null);
      this.reset();
      this.$store.commit("mendian/set_saleTotal", { total: 0, activity: 0 ,viptotal:0});
      this.dialogMergeOrder_state = false;
      if (obj.type === "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
      }
    },
    // 创建订单
    submitOrder(type) {
console.log(type,'type');
		let loading = this.$loading();
      this.o.init(this.saleList);
          if (this.saleList.length > 0) {
            let orderGoods = [];
            let tableData = this.saleList;
            console.log(tableData, "创建订单------");
            for (let i = 0; i < tableData.length; i++) {
            
              let one = {
                goodsId: tableData[i].goodsId, // 销售对象id
                goodsName: tableData[i].goodsName, // 销售对象名字
                goodsType: tableData[i].goodsType,
                brand: tableData[i].brand,
                categoryId: tableData[i].categoryId,
                categoryName: tableData[i].categoryName,
                petId: tableData[i].petId, // 销售对象id
                petName: tableData[i].petName, // 销售对象id
                skus: tableData[i].skus,
                skuValue: tableData[i].skuValue,
                barCode:tableData[i].barcode,
                unitId: tableData[i].unitId,
                unit: tableData[i].unit,
                originalPrice: tableData[i].originalPrice,
                price:this.curDiscountCard&&this.curDiscountCard._no?tableData[i].originalPrice: tableData[i].price,
                vipPrice: tableData[i].vipPrice,
                num: parseInt(tableData[i].num),
                activityId: tableData[i].activityId,
                activityName: tableData[i].activityId
                  ? tableData[i].activityItem.name
                  : "",
                payType: tableData[i].activityId
                  ? tableData[i].activityItem.pay_type
                  : "",
                totalMoney: 1,
                salesMans: tableData[i].staff.map((st) => {
                  return {
                    userId: st.split(",")[0],
                    userName: st.split(",")[1],
                  };
                }),
                goodsList: [],
                buyBack: tableData[i].buyBack,
              };
              if (tableData[i].activityType === 5) {
			      	console.log(tableData[i],"++++++++++++++++")
                // 使用了抵扣券
                one.activityId = tableData[i].goodsCouponId;
                one.activityType = 5;
                one.activityName = tableData[i].goodsCouponName;
              }
              for (let a = 0; a < tableData[i].goodsList.length; a++) {
                let two = {
                  goodsId: tableData[i].goodsList[a].goodsId, // 商品id
                  goodsName: tableData[i].goodsList[a].goodsName, // 商品名称
                  barCode: tableData[i].goodsList[a].barcode, // 条码
                  price: tableData[i].goodsList[a].price, // 销售价格
                  costPrice: tableData[i].goodsList[a].costPrice, // 销售价格
                  skus: tableData[i].goodsList[a].skus,
                  skuValue: tableData[i].goodsList[a].skuValue,
                  model: tableData[i].goodsList[a].skuValue, // 商品规格
                  unitId: tableData[i].goodsList[a].unitId,
                  unit: tableData[i].goodsList[a].unit,
                  vipPrice: tableData[i].goodsList[a].vipPrice,
                  expiryDate: tableData[i].goodsList[a].validityStopDate, // 有效期
                  goodsSalesModel: 1, // 0老数据   1出售   2赠品
                };
                one.goodsList.push(two);
              }
              if (!this.$public.isNull(tableData[i].giftList)) {
                for (let a = 0; a < tableData[i].giftList.length; a++) {
                  for (
                    let b = 0;
                    b < tableData[i].giftList[a].goodsList.length;
                    b++
                  ) {
                    let wayItem = tableData[i].giftList[a].goodsList[b];
                    let two = {
                      goodsId: wayItem.goodsId, // 商品id
                      goodsName: wayItem.goodsName, // 商品名称
                      barCode: wayItem.barcode, // 条码
                      price: wayItem.price, // 销售价格
                      vipPrice: wayItem.vipPrice,
                      costPrice: wayItem.costPrice || 0, // 销售价格
                      skus: wayItem.skus,
                      skuValue: wayItem.skuValue,
                      model: wayItem.skuValue, // 商品规格
                      unitId: wayItem.unitId,
                      unit: wayItem.unit,
                      expiryDate: wayItem.validityStopDate, // 有效期
                      goodsSalesModel: 2, // 0老数据   1出售   2赠品
                    };
                    one.goodsList.push(two);
                  }
                }
              }
              if (tableData[i].staff.length == 0) {
                this.$message({
                  message: "请选择销售人员",
                  type: "error",
                });
                loading.close();
                console.log(111111111111111);
                return;
              }
              this.getTotal()
              orderGoods.push(one);
            }
            let memberId = this.userInfo._id;
            let memberName = this.userInfo.basic_info.nick_name;
            let memberMobile = this.userInfo.basic_info.user_mobile;
            let params = {
              memberId: memberId === "sankeId" ? "" : memberId,
              memberName: memberName,
              memberMobile: memberMobile,
              totalMoney: 0,
              remark: this.remark, // 订单备注
              coupon_no:
                this.curDiscountCard !== null ? this.curDiscountCard._no : "",
              orderGoods: orderGoods,
              useVipPrice:type==1?true:false, //是否是会员
            };
			
            this.$http
              .post("/api/Order/CreateGoodsOrder", params)
              .then((res) => {
                loading.close();
                if (res.code == 0) {
                  this.combinationOrder(res.data);
                  if (this.jiedanItem && this.jiedanItem.recordId) {
                    this.$http
                      .delete("/api/HandOrder/Delete", {
                        hangOrderId: this.jiedanItem.recordId,
                      })
                      .then((res) => {
                        console.log("删除挂单", res);
                      });
                  }
                  if (memberId !== "sankeId") {
                    this.$store.dispatch("mendian/get_unPayOrderList");
                    this.$store.dispatch("mendian/getJiedaiLength");
                  }
                  this.$store.commit("mendian/reset");
                }
              });
          } else {
            // if(this.unPayOrderList.length>0&&(this.unPayOrderList.length>this.unPayOrderNoList.length)){
            // 	this.combinationOrder()
            // }else{
            // 	this.$message({
            // 		message: '没有待结算的订单',
            // 		type: 'error'
            // 	});
            // 	loading.close();
            // 	return ;
            // }
            this.$message({
              message: "没有待结算的订单",
              type: "error",
            });
            loading.close();
            return;
          }
    },
    combinationOrder(curOrder) {
      let arr = [];
      for (let i = 0; i < this.unPayOrderList.length; i++) {
        if (this.unPayOrderNoList.indexOf(this.unPayOrderList[i].no) === -1) {
          arr.push(this.unPayOrderList[i].no);
        }
      }
      this.unPayOrderList.push(curOrder);

      if (arr.length === 0) {
        // this.settlement_type = "order"
        this.curOrder = curOrder;
        this.dialogSettlement_state = true;
      } else {
        curOrder && arr.push(curOrder.no);
        this.mergeOrderNumberList = arr;
        this.dialogMergeOrder_state = true;
        // let loading = this.$loading()
        // this.$http.post('/api/Order/MergeOrder', arr).then(res => {
        // 	loading.close();
        // 	if (res.code == 0) {
        // 		this.settlement_type = "mergeOrder"
        // 		this.curOrder = res.data;
        // 		this.curOrder._id = this.curOrder.merge_order_no;
        // 		this.dialogSettlement_state = true;
        // 	}
        // })
      }
    },
    // 结算完成关闭弹窗
    dialogSettlementSubmit(a) {
      this.dialogSettlement_state = false;
      this.$store.commit("mendian/set_curDiscountCard", null);
      if (a == "close") {
        console.log("cancel");
        this.reset();
        this.$store.commit("mendian/set_saleTotal", { total: 0, activity: 0 ,viptotal:0});
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
        this.reset();
        this.$store.commit("mendian/set_saleTotal", { total: 0, activity: 0 ,viptotal:0});
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
        this.reset();
        this.$store.commit("mendian/set_saleTotal", { total: 0, activity: 0,viptotal:0 });
        if (this.curOrder.buy_back_remind === 2) {
          // 1无需提醒 2 未提醒 3 已提醒
          this.dialogReBuy_state = true;
        }
      }
    },
    submit_dialogReBuy(obj) {
      this.dialogReBuy_state = false;
      if (obj.type === "success") {
        console.log(obj);
      }
    },
    // 优惠券
    openDiscountCard() {
      if (this.saleList.length > 0) {
        let canCard = true;
        for (let i = 0; i < this.saleList.length; i++) {
          if (!this.$public.isNull(this.saleList[i].activityId) ||!this.$public.isNull(this.saleList[i].goodsCouponId)) {
            
            canCard = false;
          }
        }
        if (canCard === false ) {
          this.$message({
            message: "选择活动后不可使用优惠券！！",
            type: "error",
          });
        } else {
          this.drawerDiscountCard_state = true;
        }
      } else {
        this.$message({
          message: "请添加商品",
          type: "error",
        });
      }
    },
    submit_drawerDiscountCard(obj) {
      if (obj.type === "submit") {
        this.$store.commit("mendian/set_saleTotal", {
          total: this.saleTotal.total,
          activity: obj.newMoney,
        });
        this.$store.commit("mendian/set_curDiscountCard", obj.card);
        if (obj.card.activity_type === 3) {
          // 抵扣券
          let item1 = obj.card.canList[0];
          for (let i = 0; i < this.saleList.length; i++) {
            let item2 = this.saleList[i];
            if (
              item1.goodsId === item2.goodsId &&
              item1.skus === item2.skus &&
              item1.unitId === item2.unitId
            ) {
              this.saleList[i].activityType = 5;
            }
          }
        }
        this.$store.commit("mendian/set_saleList", this.saleList);
        this.drawerDiscountCard_state = false;
      } else {
        this.drawerDiscountCard_state = false;
      }
    },
    delDiscountCard() {
      this.$confirm("确定要删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.getTotal();
        for (let i = 0; i < this.saleList.length; i++) {
          this.saleList[i].activityType = 1;
        }
        this.$store.commit("mendian/set_saleList", this.saleList);
        this.$store.commit("mendian/set_curDiscountCard", null);
      });
    },
    // 备注
    openBeizhu() {
      this.drawerRemark_state = true;
    },
    submit_drawerRemark() {
      this.drawerRemark_state = false;
    },
    // 重置
    openReset() {
      
      this.drawerReset_state = true;
    },
    submit_drawerReset(obj) {
      if (obj.type === "success") {
        this.reset();
        this.drawerReset_state = false;
        this.$store.commit("mendian/set_saleTotal", { total: 0, activity: 0 ,viptotal:0});
      } else {
        this.drawerReset_state = false;
      }
    },
    reset() {
      this.$store.commit("mendian/reset");
    },
    // 打开挂单
    openGuadan() {
      if (this.saleList.length > 0) {
        this.drawerRemarkGuadan_state = true;
      } else {
        this.$message({
          message: "请添加商品",
          type: "error",
        });
      }
    },
    submit_drawerRemarkGuadan(obj) {
      if (obj.type === "success") {
        this.drawerRemarkGuadan_state = false;
        this.reset();
        this.$store.commit("mendian/set_saleList", []);
        this.$store.commit("mendian/set_saleTotal", { total: 0, activity: 0 ,viptotal:0});
      } else {
        this.drawerRemarkGuadan_state = false;
      }
    },
    // 解单
    openJiedan() {
      if (this.saleList.length > 0) {
        this.$message({
          message: "当前已录入商品，请先挂单",
          type: "warning",
        });
        return;
      }
      this.drawerJiedanList_state = true;
    },
    submit_drawerJiedanList(obj) {

      if (obj.type === "success") {
        this.drawerJiedanList_state = false;
        this.getTotal();
        this.$store.commit("mendian/set_saleTotal", {
          total: this.saleTotal.total,
          activity: this.jiedanItem.totalMoney,
          viptotal:this.saleTotal.viptotal,
        });
      } else {
        this.drawerJiedanList_state = false;
      }
    },
    //////////// 计算总计
    getTotal() {
      let arr = this.saleList;
      let total = {
        total: 0,
        activity: 0,
        viptotal:0,
       
      };
      for (let i = 0; i < arr.length; i++) {
        total.total = this.$public.jia(
          total.total,
          this.$public.cheng(arr[i].originalPrice, arr[i].num)
        );
        total.activity = this.$public.jia(
          total.activity,
          this.$public.cheng(arr[i].price, arr[i].num)
        );
        if(arr[i].vipPrice==0){
          total.viptotal = this.$public.jia(
          total.viptotal,
          this.$public.cheng(arr[i].originalPrice, arr[i].num)
        );
        }
        total.viptotal = this.$public.jia(
          total.viptotal,
          this.$public.cheng(arr[i].vipPrice, arr[i].num)
        );
      
      }
      console.log(total, "--------------");
      this.$store.commit("mendian/set_saleTotal", total);
    },
  },
};
</script>
<style scoped lang="scss">
.panel_settlement {
  display: flex;
  justify-content: space-between;
  padding: 10px 10px;
  background-color: #fff;
  box-shadow: 0 -3px 5px 0px #ccc;
  .priceItem {
    display: inline-flex;
    align-items: center;
    margin-right: 40px;
    .label {
      font-size: 14px;
      color: $fontColor;
    }
    .price {
      font-size: 20px;
      color: $fontColor;
    }
  }
}
</style>
